module.exports = __webpack_public_path__ + "static/ricoh-f8673fcee81c49abedce082ea6f7a210.svg";